/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowUpLeft = (
	<SVG width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<Path d="M14 6H6v8h1.5V8.5L17 18l1-1-9.5-9.5H14V6Z" />
	</SVG>
);

export default arrowUpLeft;
